import { take, call, put, fork, takeEvery } from 'redux-saga/effects';

import {
  GET_EXPORTED_FILE,
  GET_EXPORTED_FILE_TEMPLATE,
  GET_EXPORTED_CUSTOMER_IMPORT_TEMPLATE,
  GET_EXPORTED_CUSTOMER_EXPORT_TEMPLATE,
} from '../actions/get-exported-file/constants';
import * as actNotif from '../actions/notifications';
import * as act from '../actions/index';

import { getProfile } from './api/profile';
import { getOutletById } from './api/outlets';
import {
  customerServiceRetrieveImportTemplate,
  customerServiceRetrieveExportTemplate,
} from './api/customer';

function wait(millis) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, millis);
  });
}

export function* getExportedFile() {
  // noinspection InfiniteLoopJS
  while (true) {
    const request = yield take(GET_EXPORTED_FILE);
    yield put(act.sendingRequest(true));
    yield put(act.showLoadingSpinner(true));
    const { outletId } = request.payload;
    let stop = false;
    // noinspection InfiniteLoopJS
    while (!stop) {
      yield call(wait, 5000);
      const outlet = yield call(getOutletById, outletId, { refresh: true });
      if (!outlet.exporting) {
        const profile = yield call(getProfile, { refresh: true });
        window.location.href = profile.export_items_file;
        stop = true;
      }
    }

    yield put(act.sendingRequest(false));
    yield put(act.showLoadingSpinner(false));
  }
}

export function* getExportedWithoutOutlet() {
  // noinspection InfiniteLoopJS
  while (true) {
    const request = yield take(GET_EXPORTED_FILE_TEMPLATE);
    yield put(act.sendingRequest(true));
    yield put(act.showLoadingSpinner(true));
    const { filename } = request.payload;
    let stop = false;
    // noinspection InfiniteLoopJS
    while (!stop) {
      yield call(wait, 5000);
      const profile = yield call(getProfile, { refresh: true });
      if (profile.exporting === false) {
        const pattern = new RegExp(filename, 'i');
        if (!pattern.test(profile.export_items_file)) {
          yield put(actNotif.error('Failed to download file '));
        } else {
          window.location.href = profile.export_items_file;
        }
        stop = true;
      }
    }
    yield put(act.sendingRequest(false));
    yield put(act.showLoadingSpinner(false));
  }
}

export function* getExportedCustomerImportTemplate(request) {
  const { fileId } = request.payload;
  yield put(act.sendingRequest(true));
  yield put(act.showLoadingSpinner(true));
  let stop = false;
  // noinspection InfiniteLoopJS
  while (!stop) {
    yield call(wait, 5000);
    const response = yield call(customerServiceRetrieveImportTemplate, fileId);
    if (response && response.file_url) {
      window.location.href = response.file_url;
      stop = true;
    }
  }
  yield put(act.sendingRequest(false));
  yield put(act.showLoadingSpinner(false));
}

export function* getExportedCustomerExportTemplate(request) {
  const { fileId } = request.payload;
  yield put(act.sendingRequest(true));
  yield put(act.showLoadingSpinner(true));
  let stop = false;
  // noinspection InfiniteLoopJS
  while (!stop) {
    yield call(wait, 5000);
    const response = yield call(customerServiceRetrieveExportTemplate, fileId);
    if (response && response.file_url) {
      window.location.href = response.file_url;
      stop = true;
    }
  }
  yield put(act.sendingRequest(false));
  yield put(act.showLoadingSpinner(false));
}

export default function* getExportedFileSaga() {
  yield fork(getExportedFile);
  yield fork(getExportedWithoutOutlet);
  yield takeEvery(
    GET_EXPORTED_CUSTOMER_IMPORT_TEMPLATE,
    getExportedCustomerImportTemplate
  );
  yield takeEvery(
    GET_EXPORTED_CUSTOMER_EXPORT_TEMPLATE,
    getExportedCustomerExportTemplate
  );
}
